<template>
<div id="uploadImagesModal" class="modal" @click="onCloseClicked()">
    <!-- Modal content -->
    <div class="modal-content" style="height: 480px;width:500px;" @click.stop="">
        <div class="my-modal-header">
            <p style="font-weight: bold;font-size: 22px;">Upload Images</p>
            <span class="close" @click="onCloseClicked()"></span>
        </div>
        <div class="modal-body">
            <div v-if="!isUploading" style="display: flex;flex-direction: column;height: 100%;">
                <div class="row-item" style="height:107px;">
                    <div class="left-side-key">Project:</div>
                    <select v-model="targetProjectName" class="right-side-value">
                        <option v-for="proj in projects" :key="proj.id">{{proj.name}}</option>
                    </select>
                </div>
                <div class="row-item" style="height:140px;">
                    <div class="left-side-key">Scans File:</div>
                    <div class="right-side-value scan-choices-container">
                        <div class="input-row">
                            <input type="radio" id="faroScanInput" value="faro" v-model="scaneType" />
                            <div class="select-scan-btn" @click="clickOnSelectTextFile()">Faro Scene Text File</div>
                        </div>
                        <div class="input-row">
                            <input type="radio" id="leicaScanInput" value="leica" v-model="scaneType" />
                            <div class="select-scan-btn" @click="clickOnSelectTextFile()">Leica Cyclone Scan</div>
                        </div>
                        <div class="input-row">
                            <input type="radio" id="gpsScanInput" value="gps" v-model="scaneType" />
                            <div class="select-scan-btn" @click="scaneType='gps'">GPS Scan</div>
                        </div>
                        <div class="input-row">
                            <input type="radio" id="geoslamScanInput" value="geoslam" v-model="scaneType" />
                            <div class="select-scan-btn" @click="clickOnSelectTextFile()">Geoslam Scan</div>
                        </div>
                    </div>
                </div>
                <input type="file" style="display:none;" id="uploadScanFile" accept="text/txt" />
                <div class="row-item" style="flex-grow: 1;">
                    <div class="left-side-key">Images 360:</div>
                    <div class="right-side-value images-row">
                        <div class="select-scan-btn" @click="clickOnSelectImagesFiles()" style="width: 90%; margin-left: 26px;">Click To Select Images</div>
                        <div class="selected-imgs">
                            <div v-for="item in images" :key="item.id">{{item.name}}</div>
                        </div>
                        <input type="file" style="display:none;" id="multiple360Images" @change="imagesSelected($event)" accept="images/jpg" multiple />
                    </div>
                </div>
            </div>
            <CenteredText v-if="isUploading" :text="uploadingStatus" :showprogress="true"></CenteredText>
        </div>
        <div class="modal-footer" style="justify-content:center;">
            <div class="admin-btn admin-btn-secondary" @click="onCloseClicked()">Close</div>
            <div class="admin-btn" @click="upload()">Upload</div>
        </div>
    </div>
</div>
</template>

<script>
const THREE = window.THREE;
import { getRotatedDirectionByNorthAngle, convertLatLongToXYZCoordinates_Indian, readFileContent } from '@/scripts/js/forgeService';
import { Image360 } from '@/scripts/js/forgeModels';
import $ from 'jquery';
import HttpService from '../../../utils/httpService';
import CenteredText from '@/components/common/centeredText.vue';
export default {
    name: 'AdminUploadImagesPopup',
    props: ['projects'],
    data() {
        return {
            isUploading: false,
            uploadingStatus: 'Uploading...',
            scaneType: 'faro',
            images: [],
            targetProjectName: '',
        };
    },
    methods: {
        clickOnSelectTextFile() {
            document.getElementById('uploadScanFile').click();
        },
        clickOnSelectImagesFiles() {
            document.getElementById('multiple360Images').click();
        },
        imagesSelected($event) {
            this.images = $event.target.files;
        },
        getUploadXHR() {
            var xhr = new window.XMLHttpRequest();
            xhr.upload.addEventListener("progress", function (evt) {
                if (evt.lengthComputable) {
                    var progress = Math.round((evt.loaded / evt.total) * 100);
                    if (progress != 100)
                        document.getElementById('progress-bar').value = progress;
                    else {
                        document.getElementById('progress-bar')?.removeAttribute('value');
                        this.uploadingStatus = "Uploading to Blob...";
                    }
                }
            }, false);
            return xhr;
        },
        uploadGPSFiles(files) {
            if (!this.$store.state.forgeSettings || !this.$store.state.forgeSettings.gpsSettings) {
                this.$store.dispatch({
                    type: "alert_Forge",
                    message: 'GPS settings not set yet, please ask admin to set it.'
                });
                return null;
            }
            this.$store.dispatch({
                type: "prompt_Forge",
                title: "Add Elevation Z", callback: elevation => {
                    if (!elevation || !Number.parseFloat(elevation)) {
                        this.$store.dispatch({
                            type: "alert_Forge",
                            message: 'Invalid value.'
                        });
                        return null;
                    }
                    elevation = Number.parseFloat(elevation);
                    let _this = this;
                    _this.isUploading = true;
                    _this.uploadingStatus = 'Uploading...';
                    //upload images
                    let formData = new FormData();
                    formData.append("assetId", _this.$store.state.assetId);
                    formData.append("projectName", this.targetProject.name);
                    files.forEach(o => {
                        formData.append("filesToUpload", o);
                    });
                    formData.append("offsetZ", elevation);
                    //gps
                    formData.append("isIndianSystem", this.$store.state.forgeSettings.gpsSettings.isIndianSystem);
                    formData.append("gpsOriginN", this.$store.state.forgeSettings.gpsSettings.originN);
                    formData.append("gpsOriginE", this.$store.state.forgeSettings.gpsSettings.originE);
                    formData.append("gpsA", this.$store.state.forgeSettings.gpsSettings.CONST_A);
                    formData.append("gpsB", this.$store.state.forgeSettings.gpsSettings.CONST_B);
                    formData.append("gpsAngle", this.$store.state.forgeSettings.gpsSettings.angle);
                    formData.append("createdBy", _this.$store.state.username);
                    const ctrl = new AbortController(); // timeout
                    setTimeout(() => ctrl.abort(), 5000);
                    HttpService.post({
                        url: 'api/images360/uploadImages360GPS',
                        data: formData,
                        headers: {
                            'Content-Type': false,
                            'processData': false,
                        },
                        onUploadProgress: function (progressEvent) {
                            if (progressEvent.event.lengthComputable) {
                                var progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                                if (progress != 100)
                                    document.getElementById('progress-bar').value = progress;
                                else {
                                    document.getElementById('progress-bar')?.removeAttribute('value');
                                    _this.uploadingStatus = "Uploading to Blob...";
                                }
                            }
                        }
                    }).then(response => {
                        let data = response.data;
                        _this.isUploading = false;
                        if (data) {
                            if (files.length != data.length)
                                this.$store.dispatch({
                                    type: "alert_Forge",
                                    message: `${files.length - data.length} File/s skipped as not a GPS type.`
                                });
                            data = data.map(o => Object.assign(new Image360(), o));
                            for (var i = 0; i < data.length; i++) {
                                var img = data[i];
                                if (img.latLong.isIndianSystem)
                                    img.forgeCameraPosition = convertLatLongToXYZCoordinates_Indian(img.latLong);
                                else
                                    img.forgeCameraPosition = Object.assign(new THREE.Vector3(), img.forgeCameraPosition);
                                img.lockedForgeDirection = getRotatedDirectionByNorthAngle();
                                img.isVisibleInViewers = true;
                                _this.targetProject.images.push(img);
                                _this.targetProject.isExpanded = true;
                            }
                            this.$store.state.forgeService.sortByName(_this.targetProject.images);
                            this.$store.state.forgeService.update3dIconsInAllViews();
                        }
                        $('#uploadScanFile').val('');
                        $('#multiple360Images').val('');
                        _this.onCloseClicked();
                    }).catch(err => {
                        this.$store.dispatch({
                            type: "alert_Forge",
                            message: err
                        });
                    });
                }, input: {
                    inputName: "Elevation Z",
                    inputValue: ""
                }
            });
        },
        upload() {
            if (!this.targetProject) {
                this.$store.dispatch({
                    type: "alert_Forge",
                    message: 'Please select the target project first.'
                });
                return;
            }
            var imagesInput = document.getElementById('multiple360Images');
            if (!imagesInput.files || imagesInput.files.length == 0) {
                this.$store.dispatch({
                    type: "alert_Forge",
                    message: 'Please select 360 images first.'
                });
                return;
            }
            if (this.$store.state.projects.length == 0) {
                this.$store.dispatch({
                    type: "alert_Forge",
                    message: 'Please add project first.'
                });
                return;
            }
            if (this.scaneType == 'gps') {
                this.uploadGPSFiles(Array.from(imagesInput.files));
                return;
            }
            var scanInput = document.getElementById('uploadScanFile');
            if (!scanInput.files || scanInput.files.length == 0) {
                this.$store.dispatch({
                    type: "alert_Forge",
                    message: 'Please select a scan file first.'
                });
                return;
            }
            var _this = this;
            readFileContent(scanInput.files[0]).then(content => {
                var selectedFilesNames = [];
                Array.from(imagesInput.files).forEach(o => {
                    selectedFilesNames.push(o.name.split('.')[0]);
                });
                var images = this.$store.state.forgeService.textFileContentToImages(content, selectedFilesNames, _this.scaneType);
                if (images.length == 0) {
                    this.$store.dispatch({
                        type: "alert_Forge",
                        message: 'Scan file contains no scans!'
                    });
                    return;
                }
                if (images.length == 0) {
                    this.$store.dispatch({
                        type: "alert_Forge",
                        message: 'Scan information is not matching the uploaded images.'
                    });
                    return;
                }
                _this.isUploading = true;
                _this.uploadingStatus = 'Uploading...';
                //upload images
                let formData = new FormData();
                formData.append("assetId", _this.$store.state.assetId);
                formData.append("projectName", _this.targetProject.name);
                formData.append("images", JSON.stringify(images));
                Array.from(imagesInput.files).forEach(o => {
                    if (images.some(img => o.name.split('.')[0] == img.name))
                        formData.append("filesToUpload", o);
                });
                const ctrl = new AbortController(); // timeout
                setTimeout(() => ctrl.abort(), 5000);
                HttpService.post({
                    url: 'api/images360/uploadImages',
                    data: formData,
                    headers: {
                        'Content-Type': false,
                        'processData': false,
                    },
                    onUploadProgress: function (progressEvent) {
                        if (progressEvent.event.lengthComputable) {
                            var progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                            if (progress != 100)
                                document.getElementById('progress-bar').value = progress;
                            else {
                                document.getElementById('progress-bar')?.removeAttribute('value');
                                _this.uploadingStatus = "Uploading to Blob...";
                            }
                        }
                    }
                }).then(response => {
                    let data = response.data;
                    _this.isUploading = false;
                    data = data.map(o => Object.assign(new Image360(), o));
                    for (var i = 0; i < data.length; i++) {
                        var img = data[i];
                        img.isVisibleInViewers = true;
                        _this.targetProject.images.push(img);
                        _this.targetProject.isExpanded = true;
                    }
                    this.$store.state.forgeService.sortByName(_this.targetProject.images);
                    this.$store.state.forgeService.update3dIconsInAllViews();
                    $('#uploadScanFile').val('');
                    $('#multiple360Images').val('');
                    _this.onCloseClicked();
                }).catch(err => {
                    this.$store.dispatch({
                        type: "alert_Forge",
                        message: err.message
                    });
                });
            });
        },
        onCloseClicked() {
            $('#uploadImagesModal').css('display', 'none');
        },
    },
    computed: {
        targetProject: function () {
            return this.projects.find(o => o.name == this.targetProjectName);
        }
    },
    components: { CenteredText }
}
</script>

<style>
.upload-btn {
    width: 14%;
    background-color: transparent;
    border: 1px solid black;
    text-align: center;
    height: 25px;
    border-radius: 7px;
    padding-top: 6px;
    cursor: pointer;
    margin-right: 6px;
}

.upload-btn:hover {
    background-color: var(--primary-color);
}

.images-row {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: transparent;
    border: none;
}

.input-row {
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    padding-top: 3px;
}

    .selected-imgs {
        color: black;
        height: 90%;
        background-color: white;
        border: 1px solid black;
        margin: 3px 2px 1px 25px;
        overflow-y: auto;
    }

.select-scan-btn {
    width: 96%;
    height: 30px;
    color: #787878;
    cursor: pointer;
    background-color: #e9e9e9;
    border: gray;
    margin: 0 5px;
    padding-top: 5px;
    box-sizing: border-box;
}

.select-scan-btn:hover {
    background-color: lightgray;
}

.scan-choices-container {
    background-color: transparent;
    border: none;
    color: white;
    text-align: inherit;
}
</style>
